const searchParams = new URLSearchParams(window.location.search);

export const getUserIdFromQueryParams = () => {
  return searchParams.has('user') && +searchParams.get('user') ? +searchParams.get('user') : null;
};

export const getComplexIdFromQueryParams = () => {
  return searchParams.has('complex') && +searchParams.get('complex')
    ? +searchParams.get('complex')
    : null;
};

export const getDishIdFromQueryParams = () => {
  return searchParams.has('id') && +searchParams.get('id') ? +searchParams.get('id') : null;
};

export const setQueryParameter = (key, value) => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set(key, value);
  window.history.replaceState(null, null, `?${queryParams.toString()}`);
};

export const deleteQueryParameter = (key) => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.delete(key);
  window.history.replaceState(null, null, `?${queryParams.toString()}`);
};



// WEBPACK FOOTER //
// ./src/utils/url-params.js